<form
  (ngSubmit)="onFormSubmit(formModel)"
  [formGroup]="form"
  class="k-form k-form-sm"
>
  <formly-form
    [fields]="formlyFormConfig.fields"
    [form]="form"
    [model]="formModel"
  ></formly-form>
  @if (!!landParcelSearchFormActionButtonsConfig) {
    <gk-kendo-action-buttons
      [buttonsConfigs]="landParcelSearchFormActionButtonsConfig"
    ></gk-kendo-action-buttons>
  }
</form>
<kendo-loading-panel [isLoading]="isLoading | async"></kendo-loading-panel>
